import moment from "moment";
import { DEFAULT_METODO_PAGO_OPTIONS } from "./contact360.constants";

// D8.4.2 — Helpers puros de ContactProfile360Modal (extraídos del god file).

/** Evita que objetos `{}` lleguen como hijos a React / TextField. */
export function stringifyProfileEditableValue(raw) {
  if (raw == null || raw === "") return "";
  if (typeof raw === "string" || typeof raw === "number" || typeof raw === "boolean") return String(raw);
  if (typeof raw === "object") return ""; // formato inesperado en JSON perfil → no pintar objeto
  return String(raw);
}

/** Cabecera: solo texto plano. */
export function textOrEmpty(val) {
  if (typeof val === "string" || typeof val === "number") return String(val);
  return "";
}

export function isBeautyBusinessProfile(config) {
  if (!config || typeof config !== "object") return false;
  const b = config.business || config.profile || {};
  const id = b.profileId ?? b.profile_id ?? b.id ?? config.businessProfileId;
  const label = String(b.profileLabel || b.profileName || b.name || b.label || config.profileName || "").toLowerCase();
  const sId = id != null ? String(id).toLowerCase() : "";
  if (sId === "1" || sId === "p1" || sId === "belleza" || sId === "beauty") return true;
  if (label.includes("belleza") || label.includes("beauty") || label.includes("peluquer") || label.includes("salón") || label.includes("salon"))
    return true;
  return false;
}

export function buildPaymentMethodOptions(config) {
  const raw = config?.paymentMethods ?? config?.metodosPago ?? config?.payment_methods;
  if (Array.isArray(raw) && raw.length > 0) {
    return raw.map((x) =>
      typeof x === "string"
        ? { value: x.toLowerCase().replace(/\s+/g, "_"), label: x }
        : {
            value: String(x.value ?? x.id ?? x.code ?? x.name ?? "").trim() || String(x.name),
            label: String(x.name ?? x.label ?? x.value ?? "—")
          }
    );
  }
  return DEFAULT_METODO_PAGO_OPTIONS;
}

export function toDateInputValue(raw) {
  if (raw == null || raw === "") return "";
  const s = String(raw).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const m = moment(s, ["DD/MM/YYYY", "YYYY-MM-DD", moment.ISO_8601], true);
  return m.isValid() ? m.format("YYYY-MM-DD") : "";
}

export function normalizeNotasInternasLogFromProfile(pd) {
  const log = pd?.notasInternasLog;
  if (Array.isArray(log)) {
    return log
      .filter((x) => x && typeof x === "object" && String(x.text || "").trim())
      .map((x) => ({
        text: String(x.text).trim(),
        createdAt: typeof x.createdAt === "string" ? x.createdAt : undefined,
        userId: typeof x.userId === "number" ? x.userId : undefined
      }));
  }
  const legacy = pd?.notasInternas;
  if (legacy != null && String(legacy).trim() !== "") {
    return [{ text: String(legacy).trim(), createdAt: undefined }];
  }
  return [];
}

export function getAiConfidence(aiExtractedData, key) {
  const v = aiExtractedData?.[key];
  if (v == null) return null;
  if (typeof v === "number") return v;
  if (typeof v === "object" && v.confidence != null) return Number(v.confidence);
  return null;
}
